export const enum subscriptionConstants {
    GET_SUBSCRIPTION_SUMMARY_REQUEST = 'GET_SUBSCRIPTION_SUMMARY_REQUEST',
    GET_SUBSCRIPTION_SUMMARY_SUCCESS = 'GET_SUBSCRIPTION_SUMMARY_SUCCESS',
    GET_SUBSCRIPTION_SUMMARY_FAILURE = 'GET_SUBSCRIPTION_SUMMARY_FAILURE',

    GET_SUBSCRIPTION_PLANS_REQUEST = 'GET_SUBSCRIPTION_PLANS_REQUEST',
    GET_SUBSCRIPTION_PLANS_SUCCESS = 'GET_SUBSCRIPTION_PLANS_SUCCESS',
    GET_SUBSCRIPTION_PLANS_FAILURE = 'GET_SUBSCRIPTION_PLANS_FAILURE',

    GET_SUBSCRIPTION_PAYMENTS_REQUEST = 'GET_SUBSCRIPTION_PAYMENTS_REQUEST',
    GET_SUBSCRIPTION_PAYMENTS_SUCCESS = 'GET_SUBSCRIPTION_PAYMENTS_SUCCESS',
    GET_SUBSCRIPTION_PAYMENTS_FAILURE = 'GET_SUBSCRIPTION_PAYMENTS_FAILURE',

    prepareSubscriptionCheckoutRequest = 'PREPARE_SUBSCRIPTION_CHECKOUT_REQUEST',
    prepareSubscriptionCheckoutSuccess = 'PREPARE_SUBSCRIPTION_CHECKOUT_SUCCESS',
    prepareSubscriptionCheckoutFailure = 'PREPARE_SUBSCRIPTION_CHECKOUT_FAILURE',

    verifySubscriptionPaymentRequest = 'VERIFY_SUBSCRIPTION_PAYMENT_REQUEST',
    verifySubscriptionPaymentSuccess = 'VERIFY_SUBSCRIPTION_PAYMENT_SUCCESS',
    verifySubscriptionPaymentFailure = 'VERIFY_SUBSCRIPTION_PAYMENT_FAILURE',

    cancelSubscriptionRequest = 'CANCEL_SUBSCRIPTION_REQUEST',
    cancelSubscriptionSuccess = 'CANCEL_SUBSCRIPTION_SUCCESS',
    cancelSubscriptionFailure = 'CANCEL_SUBSCRIPTION_FAILURE',

    viewSubscriptionRequest = "VIEW_SUBSCRIPTION_REQUEST",
    viewSubscriptionSuccess = "VIEW_SUBSCRIPTION_SUCCESS",
    viewSubscriptionFailure = "VIEW_SUBSCRIPTION_FAILURE",

    updateSubscriptionRequest = "UPDATE_SUBSCRIPTION_REQUEST",
    updateSubscriptionSuccess = "UPDATE_SUBSCRIPTION_SUCCESS",
    updateSubscriptionFailure = "UPDATE_SUBSCRIPTION_FAILURE",

    checkSubscriptionStatusRequest = "CHECK_SUBSCRIPTION_STATUS_REQUEST",
    checkSubscriptionStatusSuccess = "CHECK_SUBSCRIPTION_STATUS_SUCCESS",
    checkSubscriptionStatusFailure = "CHECK_SUBSCRIPTION_STATUS_FAILURE",
}
